import { DEALCARD_BASE_URL } from '@/constants';
import { type PagedParams } from '@/types';
import { type PersonUpdateRequest, type PersonViewModel } from '@/types/dealcard/person';
import { GenericService } from './GenericService';

export interface PersonPagedParams extends PagedParams {
  companyId?: string;
  roles?: string[];
  salesPersonIds?: string[];
  filter?: string;
}

export class PersonService extends GenericService<PersonViewModel, PersonUpdateRequest, PersonPagedParams> {
  constructor() {
    super(DEALCARD_BASE_URL, 'people');
  }

  getPeople = async (requestParams?: PersonPagedParams): Promise<PersonViewModel[]> => {
    const result = await this.get<PersonViewModel[] | { items?: PersonViewModel[]; results?: PersonViewModel[] }>({
      baseUrl: '/api/deals',
      path: 'People',
      params: requestParams ? { ...requestParams } : undefined,
    });

    // Handle different response formats
    if (Array.isArray(result)) {
      return result;
    }

    return (result as any).items || (result as any).results || [];
  };

  getMySalesUser = async (): Promise<PersonViewModel> => {
    return await this.get({
      baseUrl: '/api/deals',
      path: 'People/me',
    });
  };
}
